import { graphql } from '@graphql/__generated'

export const ATTENDEE_BOX_GET_USERS = graphql(`
  query GetUserMetadataForAttendeeBox(
    $input: GetRegistrationFieldAnswersByEventIdInput!
  ) {
    getRegistrationFieldAnswersByEventId(input: $input) {
      items {
        name
        email
        userId
        registrationVisible
        registrationFields
      }
      total
      nextToken
    }
  }
`)
